import {
  combineReducers
} from 'redux';
// import {
//   reducer as formReducer
// } from 'redux-form';
import loaderReducer from './loaderReducer';
import LoginReducer from './LoginReducer'
import RegisterReducer from './RegisterReducer'
import MenuCategoryReducer from './MenuCategoryReducer'
import FeatureProductReducer from './FeatureProductReducer'
import NewProductListingReducer from './NewProductListingReducer'
import ProductListReducer from './ProductListReducer'
import ProductViewReducer from './ProductViewReducer'
import AddToCartReducer from './AddToCartReducer'
import CartListViewReducer from './CartListViewReducer'
import CheckOutDetailsReducer from './CheckOutDetailsReducer'
import RemoveCartItemReducer from './RemoveCartItemReducer'
import AddNewAddressReducer from './AddNewAddressReducer'
import ShowAddressListReducer from './ShowAddressListReducer'
import PlaceOrderReducer from './PlaceOrderReducer'
import DeleteAddressReducer from './DeleteAddressReducer'
import OrderHistoryListReducer from './OrderHistoryListReducer'
import ProfileDetailsListReducer from './ProfileDetailsListReducer'
import ProfileUpdateDataReducer from './ProfileUpdateDataReducer'
import ChangePasswordReducer from './ChangePasswordReducer'
import ForgotPasswordReducer from './ForgotPasswordReducer'
import VerifyPasswordReducer from './VerifyPasswordReducer'
import VariableProductDetailsReducer from './VariableProductDetailsReducer'
import CartUpdateReducer from './CartUpdateReducer'
import UploadImageReducer from './UploadImageReducer'
import SearchingListReducer from './SearchingListReducer'
import MenCustomizeReducer from './MenCustomizeReducer'
import MobileCustomizeReducer from './MobileCustomizeReducer'
import GetMobileListReducer from './GetMobileListReducer'
import WoMenCustomizeReducer from './WoMenCustomizeReducer'
import KidsCustomizeReducer from './KidsCustomizeReducer'
import emailSubscribeReducer from './emailSubscribeReducer'
import contactFormReducer from './contactFormReducer'
import OrderTrackingReducer from './OrderTrackingReducer'
import subCatListByCategoryReducer from './subCatListByCategoryReducer'
import ComboCustomizeReducer from './ComboCustomizeReducer'
import AddToCartComboReducer from './AddToCartComboReducer'
import ProductCoupleComboReducer from './ProductCoupleComboReducer'
import VariableCoupleComboReducer from './VariableCoupleComboReducer'
import HomePageBannerReducer from './HomePageBannerReducer'
import CorporateDealsFormReducer from './CorporateDealsFormReducer'
import CheckPromoCodeReducer from './CheckPromoCodeReducer';
import WalletTransationListReducer from './WalletTransationListReducer';
import CorporateKitsListReducer from './CorporateKitsListReducer';
import CorporateCustomizeProductListReducer from './CorporateCustomizeProductListReducer';
import CorporateProductViewReducer from './CorporateProductViewReducer';
import CorporateAddToCartReducer from './CorporateAddToCartReducer';
import CorporateCartListReducer from './CorporateCartListReducer';
import CorporateCartUpdateReducer from './CorporateCartUpdateReducer';
import CorporateProductRemoveReducer from './CorporateProductRemoveReducer';
import AltTextReducer from './AltTextReducer';
import CorporateShowAddressListReducer from './CorporateShowAddressListReducer';
import CorporateAddAddressReducer from './CorporateAddAddressReducer';
import CorporateDeleteAddressReducer from './CorporateDeleteAddressReducer';
import CorporateCheckOutDetailsReducer from './CorporateCheckOutDetailsReducer';
import CorporatePromoCodeReducer from './CorporatePromoCodeReducer';
import CorporatePlaceOrderReducer from './CorporatePlaceOrderReducer';
import CorporateOrderHistoryListReducer from './CorporateOrderHistoryListReducer';
import CorporateCustomizeProductViewReducer from './CorporateCustomizeProductViewReducer';
import HomePageSubBannerReducer from './HomePageSubBannerReducer';
import CsvUploadReducer from './CsvUploadReducer';
import ShowBillingReducer from './ShowBillingReducer';
import UpdateBillingReducer from './UpdateBillingReducer';

export default combineReducers({
  loading: loaderReducer,
  LoginRes: LoginReducer,
  RegisterRes: RegisterReducer,
  MenuCategoryRes: MenuCategoryReducer,
  FeatureProductRes: FeatureProductReducer,
  NewProductListingRes: NewProductListingReducer,
  ProductListRes: ProductListReducer,
  ProductViewRes: ProductViewReducer,
  AddToCartRes: AddToCartReducer,
  CartListViewRes: CartListViewReducer,
  CheckOutDetailsRes: CheckOutDetailsReducer,
  RemoveCartItemRes: RemoveCartItemReducer,
  AddNewAddressRes: AddNewAddressReducer,
  ShowAddressListRes: ShowAddressListReducer,
  PlaceOrderRes: PlaceOrderReducer,
  DeleteAddressRes: DeleteAddressReducer,
  OrderHistoryListRes: OrderHistoryListReducer,
  ProfileDetailsListRes: ProfileDetailsListReducer,
  ProfileUpdateDataRes: ProfileUpdateDataReducer,
  ChangePasswordRes: ChangePasswordReducer,
  ForgotPasswordRes: ForgotPasswordReducer,
  VerifyPasswordRes: VerifyPasswordReducer,
  VariableProductDetailsRes: VariableProductDetailsReducer,
  CartUpdateRes: CartUpdateReducer,
  UploadImageRes: UploadImageReducer,
  SearchingListRes: SearchingListReducer,
  MenCustomizeRes: MenCustomizeReducer,
  MobileCustomizeRes: MobileCustomizeReducer,
  GetMobileListRes: GetMobileListReducer,
  WoMenCustomizeRes: WoMenCustomizeReducer,
  KidsCustomizeRes: KidsCustomizeReducer,
  emailSubscribeRes: emailSubscribeReducer,
  contactFormRes: contactFormReducer,
  OrderTrackingRes: OrderTrackingReducer,
  subCatListByCategoryRes: subCatListByCategoryReducer,
  ComboCustomizeRes: ComboCustomizeReducer,
  AddToCartComboRes: AddToCartComboReducer,
  ProductCoupleComboRes: ProductCoupleComboReducer,
  VariableCoupleComboRes: VariableCoupleComboReducer,
  HomePageBannerRes: HomePageBannerReducer,
  CorporateDealsFormRes: CorporateDealsFormReducer,
  CheckPromoCodeFormRes: CheckPromoCodeReducer,
  TransationWalletListRes: WalletTransationListReducer,
  CorporateKitsListRes: CorporateKitsListReducer,
  CorporateCustomizeProductListRes: CorporateCustomizeProductListReducer,
  CorporateProductViewRes: CorporateProductViewReducer,
  CorporateAddToCartRes: CorporateAddToCartReducer,
  CorporateCartListRes: CorporateCartListReducer,
  CorporateCartUpdateRes: CorporateCartUpdateReducer,
  CorporateProductRemoveRes: CorporateProductRemoveReducer,
  AltTextRes: AltTextReducer,
  CorporateShowAddressListRes: CorporateShowAddressListReducer,
  CorporateAddAddressRes: CorporateAddAddressReducer,
  CorporateDeleteAddressRes: CorporateDeleteAddressReducer,
  CorporateCheckOutDetailsRes: CorporateCheckOutDetailsReducer,
  CorporatePromoCodeRes: CorporatePromoCodeReducer,
  CorporatePlaceOrderRes: CorporatePlaceOrderReducer,
  CorporateOrderHistoryListRes: CorporateOrderHistoryListReducer,
  CorporateCustomizeProductViewRes: CorporateCustomizeProductViewReducer,
  HomePageSubBannerRes: HomePageSubBannerReducer,
  CsvUploadRes: CsvUploadReducer,
  ShowBillingRes: ShowBillingReducer,
  UpdateBillingRes: UpdateBillingReducer,
});
